import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthenticationService } from '../http/authentication.service';
import { HttpClient } from '../http/http-client.service';
import { Settings } from '../../settings';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authService:AuthenticationService,
    private router: Router,
    private httpClient:HttpClient
  ){ 
    if(httpClient.loginAccess){
      this.authService.loginAccess = httpClient.loginAccess;
    }
  }

  canActivate() {
    // TOOD: RP Call method on authService.isUserValid():Promise that checks
    // token in local storage and sends it API for validity
    if (!!this.authService.loginAccess)
      return true;

    this.router.navigate(['login']);
    return false;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/security/auth-guard.service.ts